import { useStakingProvider } from '@trustpad/launchpad/dist/staking/hooks/useStaking';

import * as React from 'react';
import { useState } from 'react';
import CountUp from 'react-countup';
import { FaLock } from 'react-icons/fa';

import { CardTitle } from '~common/UI';
import { useModalProvider } from '~common/hooks/useModalProvider';
import { ActionButton } from '~features/ui';
import { toEthN } from '~utils';

export function ClaimCard() {
  const { userStats, totalStats, claim, pool } = useStakingProvider();
  const { setMessage } = useModalProvider();

  const [isLoading, setIsLoading] = useState(false);
  const rewardsDepleted = totalStats.rewardsLeft.eqn(0);

  async function onClick() {
    setIsLoading(true);
    await claim().then(setMessage);
    setIsLoading(false);
  }

  return (
    <div className="h-full flex flex-col justify-between">
      <div>
        <CardTitle>Pending rewards</CardTitle>

        <div className="inline-block bg-gradient-to-b from-green-700/50 rounded-2xl -m-2">
          <div className="text-3xl brand-text p-2">
            <CountUp
              end={toEthN(userStats.pendingReward)}
              decimals={2}
              preserveValue
            />{' '}
            {pool.rewardToken.symbol}
          </div>
        </div>
      </div>

      <div className="text-right mt-3 ml-auto">
        {rewardsDepleted && (
          <p className="text-xs">
            Rewards are depleted, claiming is disabled. It will be funded within
            next 24h.
          </p>
        )}
        <ActionButton
          isLoading={isLoading}
          isDisabled={
            isLoading || rewardsDepleted || toEthN(userStats.pendingReward) < 1
          }
          onClick={onClick}>
          Claim {rewardsDepleted && <FaLock className="inline" />}
        </ActionButton>
      </div>
    </div>
  );
}
